module.exports = __webpack_public_path__ + "media/public/fonts/PragmaticaSlabLight/PragmaticaSlabLight-308a1ca951e57b5feead48f7ede68208.eot";